import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Form.scss'

const Form = ({ children, inline, className, ...rest }) => {
  const classes = classNames(styles.Form, className, inline ? 'form-inline' : false)

  return (
    <form {...rest} autoComplete="off" className={classes}>
      {children}
    </form>
  )
}

export default Form

Form.propTypes = {
  children: PropTypes.any,
  inline: PropTypes.bool,
  className: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/Form/Form/index.js